// eslint-disable-next-line @typescript-eslint/no-explicit-any
async function isLoggedIn(vm: any) {
  try {
    const token = vm.$cookies.get('token');

    const { VUE_APP_TEARY_BACKEND_API_URL } = process.env;
    const apiUrl = VUE_APP_TEARY_BACKEND_API_URL;

    const req = await fetch(`${apiUrl}/users/me`, {
      method: 'get',
      headers: new Headers({
        Authorization: `${token.type} ${token.value}`,
      }),
    });

    const res = await req.json();

    if (res.ok) {
      const user = vm.$cookies.get('user');

      return res.data.id === user.id;
    }

    return false;
  } catch {
    return false;
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function redirectIfLoggedIn(vm: any) {
  if (await isLoggedIn(vm)) {
    vm.$router.push('/assignments');
    return true;
  }

  return false;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function redirectIfNotLoggedIn(vm: any) {
  if (!(await isLoggedIn(vm))) {
    vm.$router.push('/login');
    return true;
  }

  return false;
}

export default {
  redirectIfLoggedIn,
  redirectIfNotLoggedIn,
};
